import React, { useState } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Chip
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import './FAQAccordion.css';

const FAQAccordion = ({ faqs, searchQuery }) => {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  // Group FAQs by category
  const groupedFaqs = faqs.reduce((acc, faq) => {
    if (!acc[faq.category]) {
      acc[faq.category] = [];
    }
    acc[faq.category].push(faq);
    return acc;
  }, {});

  const highlightText = (text, query) => {
    if (!query.trim()) return text;
    
    const regex = new RegExp(`(${query})`, 'gi');
    const parts = text.split(regex);
    
    return parts.map((part, index) => 
      regex.test(part) ? (
        <mark key={index} className="highlight">{part}</mark>
      ) : (
        part
      )
    );
  };

  return (
    <Box className="faq-accordion">
      {Object.entries(groupedFaqs).map(([category, categoryFaqs]) => (
        <Box key={category} className="faq-category" sx={{ mb: 4 }}>
          <Box className="category-header" sx={{ mb: 2 }}>
            <Chip 
              label={category} 
              color="primary" 
              variant="outlined"
              sx={{ 
                fontSize: '0.9rem',
                fontWeight: 600,
                mb: 2
              }}
            />
          </Box>
          
          {categoryFaqs.map((faq) => (
            <Accordion
              key={faq.id}
              expanded={expanded === `panel${faq.id}`}
              onChange={handleChange(`panel${faq.id}`)}
              className="faq-item"
              sx={{
                mb: 1,
                '&:before': {
                  display: 'none',
                },
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                borderRadius: '8px !important',
                '&.Mui-expanded': {
                  margin: '0 0 8px 0',
                }
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                aria-controls={`panel${faq.id}bh-content`}
                id={`panel${faq.id}bh-header`}
                sx={{
                  '& .MuiAccordionSummary-content': {
                    margin: '16px 0',
                  }
                }}
              >
                <Typography 
                  variant="h6" 
                  sx={{ 
                    fontWeight: 600,
                    fontSize: '1.1rem',
                    color: 'text.primary'
                  }}
                >
                  {highlightText(faq.question, searchQuery)}
                </Typography>
              </AccordionSummary>
              <AccordionDetails
                sx={{
                  pt: 0,
                  pb: 2
                }}
              >
                <Typography 
                  variant="body1" 
                  sx={{ 
                    lineHeight: 1.6,
                    color: 'text.secondary'
                  }}
                >
                  {highlightText(faq.answer, searchQuery)}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      ))}
      
      {Object.keys(groupedFaqs).length === 0 && (
        <Box 
          className="no-results"
          sx={{
            textAlign: 'center',
            py: 6,
            color: 'text.secondary'
          }}
        >
          <Typography variant="h6" sx={{ mb: 1 }}>
            Aucun résultat trouvé
          </Typography>
          <Typography variant="body2">
            Essayez avec d'autres mots-clés ou contactez notre support
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default FAQAccordion;